<div class="report-filter m-3 p-5">
  <div class="row">
    <div class="col font-weight-bold text-black-50">
      Reports
    </div>
    <div class="col">
      <button (click)="toggleDateFilter()" class="btn float-right btn-lg text-white px-5 filter-orange-bg">
        {{ toggleFilter ? 'Show filter' : 'Hide filter' }}
        <i class="fas {{ icon }}"></i>
      </button>
    </div>
  </div>
  <hr />
  <div *ngIf="!toggleFilter">
    <div class="row py-1">
      <div class="col-sm-3 font-weight-bold">
        Start date
      </div>
      <div class="col-sm-3 font-weight-bold">
        End date
      </div>
      <div class="col-sm-3 font-weight-bold">
        District
      </div>
    </div>
    <div class="row pt-1 bg-light border-bottom">
      <div class="col-sm-3">
        <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Select Start Date" class="form-control"
          [(ngModel)]="startDateVal" />
        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
      </div>
      <div class="col-sm-3">
        <input [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" placeholder="Select End Date" class="form-control"
          [(ngModel)]="endDateVal" />
        <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
      </div>
      <div class="col-sm-3">
        <select class="browser-default custom-select" [(ngModel)]="district">
          <option value="All">All</option>
          <option placeholder="Select a district" *ngFor="let district of districts" [value]="district.name">
            {{ district.name }}
          </option>
        </select>
      </div>
      <div class="col-sm-3">
        <button (click)="filterQuery()" class="btn btn-md px-5 filter-teal-bg text-white float-right search_filter">
          Apply
        </button>
      </div>
    </div>
    <div *ngIf="invalidDateTime" class="row alert alert-danger alert-dismissible filter-board-size py-2 mx-1">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      <div class="col">
        Start date should not be greater than End date.
      </div>
    </div>
  </div>
</div>
